<template>
  <div class="v-sidebar">
    <Menu ref="child" accordion :active-name="active" :open-names="openName" :theme="theme2">
      <div v-for="item in navList" :key="item.menu_url">
        <MenuItem
          @click.native="subClick(item)"
          :name="item.menu_url"
          v-if="!item.children||!item.children.length"
        >{{item.title}}</MenuItem>
        <Submenu :key="item.menu_url" :name="item.menu_url" v-else>
          <template slot="title">{{item.title}}</template>
          <MenuItem
            :key="child.menu_url"
            v-for="child in item.children"
            @click.native="subClick(child,item)"
            :name="child.menu_url"
          >{{child.title}}</MenuItem>
        </Submenu>
      </div>
    </Menu>
  </div>
</template>

<script>
export default {
  data() {
    return {
      theme2: "light",
      openName: [],
      active: ""
    };
  },
  computed: {
    navList() {
      return this.$store.state.leftMenus;
    },
    storeOpenName() {
      return this.$store.state.openName;
    }
  },
  watch: {
    $route() {
      this.active = this.$store.state.currentLeftMenu
        ? this.$store.state.currentLeftMenu
        : this.$route.meta.parent
        ? this.$route.meta.parent
        : this.$route.name;
      this.openName = [sessionStorage.openName];
      this.$nextTick(() => {
        this.$refs.child.updateOpened();
        this.$refs.child.updateActiveName();
      });
    },
    storeOpenName() {
      this.openName = [this.storeOpenName];
      this.$nextTick(() => {
        this.$refs.child.updateOpened();
        this.$refs.child.updateActiveName();
      });
    }
  },
  created() {
    if (this.$route.name == "Main" || this.$route.name == "Home") {
      return;
    }
    this.active = this.$store.state.currentLeftMenu
      ? this.$store.state.currentLeftMenu
      : this.$route.meta.parent
      ? this.$route.meta.parent
      : this.$route.name;
    let open = sessionStorage.openName
      ? sessionStorage.openName
      : this.navList.length > 0
      ? this.navList[0].menu_url
      : "";
    this.openName = [open];
    this.$nextTick(() => {
      this.$refs.child.updateOpened();
      this.$refs.child.updateActiveName();
    });
  },
  updated() {},
  methods: {
    subClick(item, parent) {
      this.active = item.menu_url;
      this.$router.push({
        name: item.menu_url
      });
      if (parent) {
        this.$store.commit("setOpenName", parent.menu_url);
      }
    }
  }
};
</script>

<style scoped>
.v-sidebar {
  height: calc(100vh - 65px);
  background: #fff;
  border: none;
}

.ivu-menu-light {
  background: none;
}

.ivu-menu {
  width: 170px !important;
}

.ivu-menu-vertical.ivu-menu-light:after {
  display: none;
}

.ivu-menu-child-item-active .ivu-menu-submenu-title {
  color: #2d8cf0;
}

::-webkit-scrollbar {
  width: 2px;
}

::-webkit-scrollbar-thumb {
  background-color: #d4d8e2;
}

.ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu) {
  background-color: #fff;
}

.ivu-menu-light.ivu-menu-vertical
  .ivu-menu-item-active:not(.ivu-menu-submenu)::after {
  display: none;
}

.ivu-menu-submenu-title span > i,
.ivu-menu-submenu-title > i {
  width: 14px !important;
}
</style>
